import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMailingList } from '../../redux/actions/chat/getMailingList';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal, Pagination } from 'antd';
import dayjs from 'dayjs';
import SelectionPerformer from '../SelectionPerformer';
import { getMailingUsers } from '../../redux/actions/chat/getMailingUsers';
import { resetGetMailingList, resetGetMailingUsers } from '../../redux/slices/chat.slice';

export default function MailinList() {
  const {
    getMailingList: { data: getMailingListData, error: getMailingListError, loading: getMailingListLoading },
  } = useSelector((state) => state.chat);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getMailingList());
    dispatch(getMailingUsers({ mailing_id: 13 }));
    return () => {
      dispatch(resetGetMailingList());
    };
  }, []);
  const form = useForm();
  const currentPage = form.watch('page');
  const { pathname } = useLocation();
  const [openCandidateModal, setOpenCandidateModal] = useState();
  const navigate = useNavigate();
  React.useEffect(() => {
    const subscription = form.watch((value, { name, type }) => {
      if (name == 'page') {
        dispatch(getMailingList({ page: value.page }));
      }
    });
    return () => subscription.unsubscribe();
  }, [form.watch]);
  const onClickRow = (data) => {
    setOpenCandidateModal(data);
  };
  const [hoverId, setHoverId] = useState();
  const onHover = (id) => {
    setHoverId(id);
  };
  const onHoverLeave = () => {
    setHoverId(null);
  };
  return (
    <div className="mx-auto flex flex-1 flex-col w-full max-w-[1163px]">
      <div className="w-full mt-6 p-2">
        <div className="flex flex-row justify-between gap-1">
          <div className="flex items-center gap-2">
            <ul className=" flex list-none gap-3 border-b border-gray-200 justify-start items-baseline flex-wrap text-2xl">
              <li
                key={'1'}
                onClick={() => {
                  navigate('/chats');
                }}
                className={`cursor-pointer hover:text-[#00B2A4] pb-1 ${pathname == '/chats' ? 'font-bold text-[#00B2A4]' : 'border-b-1 border-[#00B2A4] border-dotted '}`}>
                Чаты
              </li>
              <li
                key={'2'}
                onClick={() => {
                  navigate('/messages');
                }}
                className={`cursor-pointer hover:text-[#00B2A4] pb-1 ${pathname == '/messages' ? 'font-bold text-[#00B2A4]' : 'border-b-1 border-[#00B2A4] border-dotted '}`}>
                Мои сообщения
              </li>{' '}
              <li
                key={'3'}
                onClick={() => {
                  navigate('/mailing');
                }}
                className={`cursor-pointer hover:text-[#00B2A4] pb-1 ${pathname == '/mailing' ? 'font-bold text-[#00B2A4]' : 'border-b-1 border-[#00B2A4] border-dotted '}`}>
                Рассылка
              </li>
            </ul>{' '}
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col first:flex-row zero:justify-evenly">
        <div className="flex w-full flex-col zero:w-[100%] p-2">
          <div className={'mt-3'}>
            <div
              className={clsx('flex flex-col w-full border-1 border-[#C4C4C4] shadow-lg rounded-md', 'p-6')}
              // isSelf ? 'pb-3' : 'p-6'
            >
              {getMailingListData?.results?.length ? (
                <>
                  <div className="" style={{ display: 'grid', gridTemplateColumns: '60px auto auto auto auto', userSelect: 'none', cursor: 'pointer' }}>
                    {getMailingListData?.results?.map((item) => (
                      <>
                        <div className={clsx('p-3', item?.id == hoverId && 'bg-gray-100')} onMouseEnter={() => onHover(item?.id)} onMouseLeave={() => onHoverLeave()} onClick={() => onClickRow(item)}>
                          {item?.id}
                        </div>
                        <div className={clsx('p-3', item?.id == hoverId && 'bg-gray-100')} onMouseEnter={() => onHover(item?.id)} onMouseLeave={() => onHoverLeave()} onClick={() => onClickRow(item)}>
                          {item?.sender?.full_name}
                        </div>
                        <div className={clsx('p-3 text-gray-400', item?.id == hoverId && 'bg-gray-100')} onMouseEnter={() => onHover(item?.id)} onMouseLeave={() => onHoverLeave()} onClick={() => onClickRow(item)}>
                          <div
                            style={{
                              height: '24px',
                              display: '-webkit-box',
                              WebkitBoxOrient: 'vertical',
                              WebkitLineClamp: 1,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}>
                            {item?.message}
                          </div>
                        </div>
                        <div className={clsx('p-3 text-gray-400 underline underline-offset-4 under', item?.id == hoverId && 'bg-gray-100')} style={{ textDecorationThickness: '1px' }} onMouseEnter={() => onHover(item?.id)} onMouseLeave={() => onHoverLeave()} onClick={() => onClickRow(item)}>
                          Получатели
                        </div>
                        <div className={clsx('p-3 text-gray-400 text-end', item?.id == hoverId && 'bg-gray-100')} onMouseEnter={() => onHover(item?.id)} onMouseLeave={() => onHoverLeave()} onClick={() => onClickRow(item)}>
                          {dayjs(item.created_at).format('HH:mm DD.MM.YY')}
                        </div>
                      </>
                    ))}
                  </div>
                  <Pagination
                    className="flex items-center justify-center mt-4"
                    defaultCurrent={currentPage}
                    total={getMailingListData?.count}
                    showSizeChanger={false}
                    current={currentPage}
                    disabled={getMailingListLoading}
                    onChange={(e) => {
                      form.setValue('page', e);
                    }}
                  />
                </>
              ) : (
                <div className="relative h-[432px]">
                  {' '}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xl opacity-50 font-bold">Рассылок нет</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="select-user-modal"
        style={{ height: 'calc(100vh - 40px)' }}
        title={``}
        centered
        open={openCandidateModal}
        width={'100%'}
        onCancel={() => {
          setOpenCandidateModal(false);
        }}
        footer={['']}>
        <SelectionPerformer
          key={openCandidateModal?.id}
          sliceName={'chat'}
          actionName={'getMailingUsers'}
          isMailing={true}
          title={'Получатели уведомления'}
          mailingId={openCandidateModal?.id}
          mailingMessage={openCandidateModal?.message}
          onSendApplicant={(val) => {
            console.log('employer id', val);
            // dispatch(
            //   sendMessage({
            //     chat_id: chatId,
            //     content_type: 'candidate',
            //     candidate_id: val,
            //   }),
            // );
          }}
          isApplicants
          onClose={() => {
            dispatch(resetGetMailingUsers());
            setOpenCandidateModal(false);
          }}
        />
      </Modal>
    </div>
  );
}
